// context/ConversationContext.js - VERSION CORRIGÉE
import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { API_BASE_URL } from '../config'; // ✅ Import depuis config.js
import api from '../services/api'; // <-- ajoute ça en haut
 
const ConversationContext = createContext();

// ❌ SUPPRIMÉ : const API_BASE_URL = 'http://localhost:5000/api';
// ❌ SUPPRIMÉ : console.log('🔍 API_BASE_URL utilisée:', API_BASE_URL);
// ❌ SUPPRIMÉ : console.log('🔍 Variable env:', process.env.REACT_APP_API_URL);

// ✅ AJOUTÉ : Vérification au bon endroit (dans le Provider)
console.log('🔧 ConversationContext utilise API_BASE_URL:', API_BASE_URL);

export const useConversations = () => {
    const context = useContext(ConversationContext);
    if (!context) {
        throw new Error('useConversations doit être utilisé dans un ConversationProvider');
    }
    return context;
};

export const ConversationProvider = ({ children }) => {
    const [conversations, setConversations] = useState([]);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Fonctions utilitaires avec useCallback pour corriger ESLint
    const getAuthToken = useCallback(() => localStorage.getItem('token'), []);
    
    const getAuthHeaders = useCallback(() => ({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`
    }), [getAuthToken]);

    // Charger les informations utilisateur depuis l'API
    const loadUser = useCallback(async () => {
        try {
            // ✅ CORRECTION : Utiliser API_BASE_URL sans /api (déjà inclus dans config.js)
            const response = await fetch(`${API_BASE_URL}/auth/profile`, {
                headers: getAuthHeaders()
            });

            if (response.ok) {
                const userData = await response.json();
                console.log('👤 Utilisateur chargé:', userData);
                
                setUser(userData.user);
                localStorage.setItem('user', JSON.stringify(userData.user));
                return userData.user;
            } else {
                console.error('Erreur chargement utilisateur:', response.status);
                return null;
            }
        } catch (error) {
            console.error('Erreur loadUser:', error);
            return null;
        }
    }, [getAuthHeaders]);

    // Charger toutes les conversations
    const loadConversations = useCallback(async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/conversations`, {
                headers: getAuthHeaders()
            });

            if (response.ok) {
                const data = await response.json();
                setConversations(data.conversations || []);
                return data.conversations;
            } else {
                console.error('Erreur chargement conversations');
                return [];
            }
        } catch (error) {
            console.error('Erreur loadConversations:', error);
            return [];
        }
    }, [getAuthHeaders]);

    // Fonction de rafraîchissement complète
    const refreshData = useCallback(async () => {
        setLoading(true);
        try {
            await Promise.all([
                loadUser(),
                loadConversations()
            ]);
        } catch (error) {
            console.error('Erreur refreshData:', error);
        } finally {
            setLoading(false);
        }
    }, [loadUser, loadConversations]);

    // Créer une nouvelle conversation
    const createConversation = useCallback(async (girlInfo) => {
        try {
            console.log('📝 Création conversation - Données reçues:', girlInfo);
            
            const requestBody = {
                title: girlInfo.name || 'Nouvelle conversation',
                girl_info: girlInfo
            };
            
            console.log('📤 Envoi vers API:', requestBody);
            
            const response = await fetch(`${API_BASE_URL}/conversations`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();
            console.log('📥 Réponse serveur:', data);

            if (response.ok && data.success) {
                await refreshData();
                return data.conversation.id;
            } else {
                throw new Error(data.message || 'Erreur création conversation');
            }
        } catch (error) {
            console.error('❌ Erreur createConversation:', error);
            throw error;
        }
    }, [getAuthHeaders, refreshData]);

    // Ajouter un message - FONCTION COMPLÈTE
    const addMessage = useCallback(async (conversationId, role, content, metadata = {}) => {
        try {
            console.log('📨 Ajout message:', { conversationId, role, content, metadata });

            const requestBody = {
                conversation_id: conversationId,
                content: content,
                message_type: metadata.message_type || 'generation_request',
                style_requested: metadata.style_requested || 'humour'
            };

            // Support pour les styles multiples
            if (metadata.styles_requested && Array.isArray(metadata.styles_requested)) {
                requestBody.styles_requested = metadata.styles_requested;
            }

            // Support pour form_data (Date Planning)
            if (metadata.form_data) {
                requestBody.form_data = metadata.form_data;
                console.log('📋 Form data ajouté:', metadata.form_data);
            }

            // Support pour ghosting_data (Anti-Ghosting)
            if (metadata.ghosting_data) {
                requestBody.content = JSON.stringify(metadata.ghosting_data);
            }

            console.log('📤 Requête envoyée au backend:', requestBody);

            const response = await fetch(`${API_BASE_URL}/messages/generate`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (response.ok) {
                console.log('✅ Message ajouté avec succès');
                await loadUser();
                await loadConversations();
                return data;
            } else {
                console.error('❌ Erreur ajout message:', data.message);
                if (response.status === 402) {
                    throw new Error(`Crédits insuffisants (${data.required} requis)`);
                }
                throw new Error(data.message || 'Erreur lors de l\'ajout du message');
            }
        } catch (error) {
            console.error('❌ Erreur ajout message:', error);
            throw error;
        }
    }, [getAuthHeaders, loadUser, loadConversations]);

    const refreshUserProfile = useCallback(async () => {
    console.log('🔄 Début refreshUserProfile');
    
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            console.log('❌ Pas de token, redirection vers login');
            setUser(null);
            setLoading(false);
            return;
        }

        // 🔥 UTILISE LE CLIENT API
        const response = await api.get('/auth/profile');
        
        const data = response.data;
        
        console.log('📥 Réponse profil complète:', data);

        if (data.success && data.user) {
            const userWithSubscription = {
                ...data.user,
                subscription: data.user.subscription || null,
                remaining_credits: data.user.remaining_credits || 0
            };
            
    console.log('✅ Données utilisateur structurées:', {
    username: userWithSubscription.username,
    email: userWithSubscription.email,
    subscription: userWithSubscription.subscription,
    remaining_credits: userWithSubscription.remaining_credits  // ⭐ Changé
});
            
            setUser(userWithSubscription);
            
            if (userWithSubscription.subscription) {
                console.log('🎯 Abonnement détecté:', {
                    plan: userWithSubscription.subscription.plan_name,
                    active: userWithSubscription.subscription.is_active,
                    expires: userWithSubscription.subscription.expires_at,
                    status: userWithSubscription.subscription.status
                });
            } else {
                console.log('⚠️ Aucun abonnement actif trouvé');
            }
        } else {
            console.error('❌ Réponse profil invalide:', data);
            
            // Ne pas supprimer le token en cas d'erreur temporaire
            setUser(null);
        }
    } catch (error) {
        console.error('❌ Erreur refreshUserProfile:', error);
        
        // 🔥 Si erreur 401, déconnecter
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setUser(null);
        }
    } finally {
        setLoading(false);
    }
}, []);

    const debugSubscriptionData = useCallback(() => {
        console.log('=== DEBUG SUBSCRIPTION DATA ===');
        console.log('User object:', user);
        console.log('Has subscription:', !!user?.subscription);
        console.log('Plan name:', user?.subscription?.plan_name);
        console.log('Is active:', user?.subscription?.is_active);
        console.log('Expires at:', user?.subscription?.expires_at);
        console.log('Credits:', user?.credits);
        console.log('===============================');
    }, [user]);

    // Générer des réponses anti-ghosting
    const generateAntiGhosting = useCallback(async (ghostingData, conversationId) => {
        try {
            console.log('👻 Début génération anti-ghosting');
            
            const requestBody = {
                conversation_id: conversationId,
                content: JSON.stringify(ghostingData),
                message_type: 'anti_ghosting'
            };

            const response = await fetch(`${API_BASE_URL}/messages/generate`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (response.ok) {
                console.log('✅ Anti-ghosting généré avec succès');
                await loadUser();
                return data.anti_ghosting_responses;
            } else {
                console.error('❌ Erreur anti-ghosting:', data.message);
                if (response.status === 402) {
                    throw new Error(`Crédits insuffisants (${data.required} requis)`);
                }
                throw new Error(data.message || 'Erreur lors de la génération anti-ghosting');
            }
        } catch (error) {
            console.error('❌ Erreur génération anti-ghosting:', error);
            throw error;
        }
    }, [getAuthHeaders, loadUser]);

    // Analyser les sentiments
    const analyzeSentiment = useCallback(async (herResponse, conversationId) => {
        try {
            console.log('🧠 Début analyse de sentiments');
            
            const requestBody = {
                her_response: herResponse,
                conversation_id: conversationId
            };

            const response = await fetch(`${API_BASE_URL}/premium/analyze-sentiment`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (response.ok) {
                console.log('✅ Analyse réussie');
                await loadUser();
                return data.analysis;
            } else {
                console.error('❌ Erreur analyse:', data.message);
                if (response.status === 402) {
                    throw new Error(`Crédits insuffisants (${data.required} requis)`);
                }
                throw new Error(data.message || 'Erreur lors de l\'analyse');
            }
        } catch (error) {
            console.error('❌ Erreur analyse sentiments:', error);
            throw error;
        }
    }, [getAuthHeaders, loadUser]);

    // Reformuler un message
    const reformulateMessage = useCallback(async (originalMessage, conversationId) => {
        try {
            console.log('🪄 Début reformulation message');
            
            const requestBody = {
                original_message: originalMessage,
                conversation_id: conversationId,
                context: {}
            };

            const response = await fetch(`${API_BASE_URL}/premium/reformulate-message`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (response.ok) {
                console.log('✅ Reformulation réussie');
                await loadUser();
                
                const reformulations = data.reformulations;
                
                if (reformulations && reformulations.reformulations && Array.isArray(reformulations.reformulations)) {
                    return reformulations;
                } else if (reformulations && Array.isArray(reformulations)) {
                    return {
                        original: originalMessage,
                        reformulations: reformulations
                    };
                } else {
                    console.warn('⚠️ Structure de reformulation inattendue:', reformulations);
                    return {
                        original: originalMessage,
                        reformulations: [
                            {
                                version: "douce",
                                emoji: "💸",
                                text: originalMessage.replace(/!/g, '.'),
                                effect: "Ton plus doux et bienveillant"
                            },
                            {
                                version: "confiante",
                                emoji: "💪",
                                text: originalMessage + " 😎",
                                effect: "Assurance masculine renforcée"
                            },
                            {
                                version: "mystérieuse",
                                emoji: "🎭",
                                text: originalMessage.replace(/\./g, '...') + "...",
                                effect: "Ajoute du mystère et de l'intrigue"
                            },
                            {
                                version: "directe",
                                emoji: "🎯",
                                text: originalMessage.replace(/peut-être|sans doute|je pense que/g, '').trim(),
                                effect: "Communication franche et claire"
                            }
                        ]
                    };
                }
            } else {
                console.error('❌ Erreur reformulation:', data.message);
                if (response.status === 402) {
                    throw new Error(`Crédits insuffisants (${data.required} requis)`);
                }
                throw new Error(data.message || 'Erreur lors de la reformulation');
            }
        } catch (error) {
            console.error('❌ Erreur reformulation message:', error);
            throw error;
        }
    }, [getAuthHeaders, loadUser]);

    // Mettre à jour les informations utilisateur
    const updateUserInfo = useCallback(async (newUserData) => {
        try {
            const response = await fetch(`${API_BASE_URL}/auth/update-profile`, {
                method: 'PUT',
                headers: getAuthHeaders(),
                body: JSON.stringify(newUserData)
            });

            const data = await response.json();

            if (data.success) {
                setUser(data.user);
                localStorage.setItem('user', JSON.stringify(data.user));
                return { success: true, user: data.user };
            } else {
                return { success: false, message: data.message };
            }
        } catch (error) {
            console.error('Erreur mise à jour profil:', error);
            return { success: false, message: 'Erreur de connexion au serveur' };
        }
    }, [getAuthHeaders]);

    // Changer le mot de passe
    const changePassword = useCallback(async (passwordData) => {
        try {
            const response = await fetch(`${API_BASE_URL}/auth/change-password`, {
                method: 'PUT',
                headers: getAuthHeaders(),
                body: JSON.stringify(passwordData)
            });

            const data = await response.json();
            return { success: data.success, message: data.message, warnings: data.warnings };
        } catch (error) {
            console.error('Erreur changement mot de passe:', error);
            return { success: false, message: 'Erreur de connexion au serveur' };
        }
    }, [getAuthHeaders]);

    // Récupérer les informations de sécurité
    const getSecurityInfo = useCallback(async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/auth/security-info`, {
                headers: getAuthHeaders()
            });

            const data = await response.json();
            return { success: data.security, security: data.security };
        } catch (error) {
            console.error('Erreur récupération sécurité:', error);
            return { success: false, message: 'Erreur de connexion au serveur' };
        }
    }, [getAuthHeaders]);

    // Récupérer les coûts en crédits depuis le serveur
    const getCreditCosts = useCallback(async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/messages/credit-costs`, {
                headers: getAuthHeaders()
            });

            if (response.ok) {
                const data = await response.json();
                return data.costs;
            }
        } catch (error) {
            console.error('Erreur récupération coûts:', error);
        }
        // Fallback
        return {
            message_generation: 20,
            first_message: 30,
            anti_ghosting: 30,
            sentiment_analysis: 30,
            message_reformulate: 10,
            date_planning: 70
        };
    }, [getAuthHeaders]);

    // Supprimer une conversation
    const deleteConversation = useCallback(async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}/conversations/${id}`, {
                method: 'DELETE',
                headers: getAuthHeaders()
            });

            if (response.ok) {
                await refreshData();
                return true;
            } else {
                throw new Error('Erreur lors de la suppression');
            }
        } catch (error) {
            console.error('❌ Erreur deleteConversation:', error);
            throw error;
        }
    }, [getAuthHeaders, refreshData]);

    // Mettre à jour le statut d'une conversation
    const updateConversationStatus = useCallback(async (id, status) => {
        try {
            const response = await fetch(`${API_BASE_URL}/conversations/${id}/status`, {
                method: 'PUT',
                headers: getAuthHeaders(),
                body: JSON.stringify({ status })
            });

            if (response.ok) {
                await refreshData();
                return true;
            } else {
                throw new Error('Erreur lors de la mise à jour du statut');
            }
        } catch (error) {
            console.error('❌ Erreur updateConversationStatus:', error);
            throw error;
        }
    }, [getAuthHeaders, refreshData]);

    // Simuler un achat d'abonnement (pour tests)
    const simulatePurchase = useCallback(async (planName) => {
        try {
            const response = await fetch(`${API_BASE_URL}/premium/simulate-purchase`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify({ 
                    plan_name: planName,
                    transaction_id: `sim_${Date.now()}`
                })
            });

            const data = await response.json();

            if (response.ok) {
                console.log('✅ Achat simulé avec succès');
                await loadUser();
                return data;
            } else {
                throw new Error(data.message || 'Erreur lors de la simulation d\'achat');
            }
        } catch (error) {
            console.error('❌ Erreur simulatePurchase:', error);
            throw error;
        }
    }, [getAuthHeaders, loadUser]);

    // Récupérer les plans d'abonnement disponibles
    const getAvailablePlans = useCallback(async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/premium/plans`, {
                headers: getAuthHeaders()
            });

            if (response.ok) {
                const data = await response.json();
                return data.plans;
            }
        } catch (error) {
            console.error('Erreur récupération plans:', error);
        }
        return null;
    }, [getAuthHeaders]);

    // Récupérer l'historique d'usage premium
    const getPremiumUsageHistory = useCallback(async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/premium/usage-history`, {
                headers: getAuthHeaders()
            });

            if (response.ok) {
                const data = await response.json();
                return data;
            }
        } catch (error) {
            console.error('Erreur récupération historique:', error);
        }
        return null;
    }, [getAuthHeaders]);

    // Fonctions utilitaires simples
    const getConversation = useCallback((id) => {
        return conversations.find(conv => conv.id === id);
    }, [conversations]);

    const getAllConversations = useCallback(() => {
        return conversations;
    }, [conversations]);

    // Initialisation
    useEffect(() => {
        const initializeData = async () => {
            const token = getAuthToken();
            if (token) {
                const storedUser = localStorage.getItem('user');
                if (storedUser) {
                    try {
                        setUser(JSON.parse(storedUser));
                    } catch (error) {
                        console.error('Erreur parsing user localStorage:', error);
                    }
                }
                await refreshData();
            } else {
                setLoading(false);
            }
        };

        initializeData();
    }, [getAuthToken, refreshData]);

    const value = {
        // État
        conversations,
        user,
        loading,

        // Fonctions principales
        refreshData,
        createConversation,
        addMessage,
        getConversation,
        getAllConversations,
        deleteConversation,
        updateConversationStatus,

        // Fonctions premium
        analyzeSentiment,
        reformulateMessage,
        generateAntiGhosting,
        getCreditCosts,
        refreshUserProfile,
        debugSubscriptionData,

        // Fonctions d'abonnement
        simulatePurchase,
        getAvailablePlans,
        getPremiumUsageHistory,

        // Fonctions Mon Compte
        updateUserInfo,
        changePassword,
        getSecurityInfo,

        // Utilitaires
        getAuthHeaders
    };

    return (
        <ConversationContext.Provider value={value}>
            {children}
        </ConversationContext.Provider>
    );
};